// src/components/ui/list/list-cell-text.js
import React from 'react';
import PropTypes from 'prop-types';
import { ListItemText } from '@mui/material';

const ListCellText = ({
  primary,
  secondary,
  align = 'left',
  fontSize = '0.875rem',
  fontWeight = 400,
  color = 'inherit',
  flex = '0 0 auto', // required to always use flex
  sx = {},
  ...props
}) => {
  const isPlainText = typeof primary === 'string' || typeof primary === 'number';
  
  return (
    <ListItemText
      primary={primary}
      secondary={secondary}
      disableTypography={!isPlainText}
      primaryTypographyProps={{
        variant: 'body2',
        fontSize,
        fontWeight,
        textAlign: align,
        color,
      }}
      sx={{
        flex,
        display: 'flex',
        flexDirection: 'column',
        alignItems: align === 'right' ? 'flex-end' : align === 'center' ? 'center' : 'flex-start',
        ...sx,
      }}
      {...props}
    />
  );
};

ListCellText.propTypes = {
  primary: PropTypes.node,
  secondary: PropTypes.node,
  align: PropTypes.oneOf(['left', 'right', 'center']),
  fontSize: PropTypes.string,
  fontWeight: PropTypes.number,
  color: PropTypes.string,
  flex: PropTypes.string,
  sx: PropTypes.object,
};

export default ListCellText;
